<template>
  <div id="buy-lifetime">
    <div class="container" v-if="price">
      <el-row v-if="!license" type="flex" justify="center">
        <el-col :md="12">
          <el-card show variant="primary">
            <el-tag variant="danger">BTC</el-tag>
            <el-tag variant="secondary">BCH</el-tag>
            <el-tag variant="success">ETH</el-tag>
            <el-tag variant="dark">LTC</el-tag>
            <h1>${{ price.toFixed(2) }}</h1>
            <p>
              PTDefender requires a one-time purchase of ${{ price.toFixed(2) }}. We securely process payments in BTC, BCH, ETH, or LTC using the Coinbase Commerce platform. Simply enter your email address below to start the payment process.
            </p>
            <hr>
            <p>
              <strong>Important:</strong> Make sure you enter a valid email address that only you have access to. Once the payment is processed we will send your License to the email address you provide.
            </p>
          </el-card>
          <el-form>
            <el-input v-model="email" @keyup.enter="submit" placeholder="john@doe.com">
              <template slot="prepend">Email</template>
            </el-input>
            <hr>
            <el-row :gutter="8">
              <el-col :md="16">
                <div ref="cardElement"></div>
              </el-col>
              <el-col :md="8">
                <el-button @click="payViaStripe" class="credit-card" type="submit" variant="primary" :loading="loadingCard" :disabled="!email">
                  Complete Purchase
                </el-button>
              </el-col>
            </el-row>
            <el-row>
              <p class="or">or</p>
            </el-row>
            <el-row :gutter="10">
              <el-col :md="24">
                <el-button @click="payViaCoinbase" class="crypto" type="submit" variant="primary" :loading="loadingCrypto" :disabled="!email">
                  Pay with Crypto
                </el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <div v-if="license" class="container license">
      <el-row type="flex" justify="center">
        <el-col :md="12">
          <el-card>
            <h1>Purchase Complete</h1>
            <p>
              Here is your PTDefender License:
            </p>
            <p>
              <code>
                <pre>{{ license }}</pre>
              </code>
            </p>
            <hr>
            <p>
              <strong>Important:</strong> Make sure you keep this license in a safe place. After downloading PTDefender you will need to enter this license in order to activate it.
            </p>
            <br>
            <p>
              <router-link to="/download">Download PTDefender</router-link>
            </p>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import api from 'lib/api'
import referral from 'lib/referral'
import Stripe from 'lib/stripe'

export default {
  name: 'Buy',
  props: [
    'referral'
  ],
  data() {
    return {
      price: 149,
      email: null,
      card: null,
      loadingCard: false,
      loadingCrypto: false,
      license: null
    }
  },
  methods: {
    getReferral() {
      return referral.current() || this.referral || null
    },
    async payViaCoinbase(event) {
      if (event) event.preventDefault()
      this.loadingCrypto = true
      try {
        await api.checkout({
          email: this.email,
          referral: this.getReferral()
        })
        this.email = null
        this.$alert('Check your email for a link to complete your purchase!')
      } catch(err) {
        this.alertError(err)
      }
      this.loadingCrypto = false
    },
    async payViaStripe(event) {
      if (event) event.preventDefault()
      this.loadingCard = true
      try {
        let token = await this.stripe.createToken(this.card)
        let auth = await api.register({
          token: token.id,
          email: this.email,
          referral: this.getReferral()
        })
        this.license = auth.token
      } catch(err) {
        this.alertError(err)
      }
      this.loadingCard = false
    },
    alertError(err) {
      if (err.type === 'validation_error') return
      let title = err.response ? err.response.data.title : 'Error'
      let message = err.response ? err.response.data.message : err.message
      return this.$alert(message || 'Please try again', title || 'Something went wrong')
    }
  },
  async mounted() {
    this.price = await api.price()
    this.stripe = new Stripe()
    this.card = this.stripe.createCard(this.$refs.cardElement)
    if (this.referral) {
      referral.set(this.referral)
    }
  }
}
</script>

<style lang="scss">
#buy-lifetime {
  padding: 150px 8px 200px 8px;

  code pre {
    padding: 8px;
    background-color: #f4f5f6;
    border-radius: 3px;
    border: 1px solid darken(#f4f5f6, 10%);
  }

  p.or {
    text-align: center;
    color: #aaa;
  }

  .el-tag {
    margin-right: 6px;
    margin-bottom: 12px;
  }

  .el-input {
    margin-top: 20px;
  }

  .el-button {
    color: #fff !important;
    width: 100%;
    height: 39px;
  }

  a {
    color: #1b6163;
    text-decoration: underline;
  }

  .el-button {
    text-transform: none;
    border: none;
    padding: 10px;
    &.credit-card {
      background-color: #00ce85;
    }
    &.crypto {
      background-color: #4a4cff;
    }
  }
}
</style>
